import { FunctionComponent, useId } from "react";
import { Textarea } from "@pjs/core-ui";
import { userUiI18n } from "../../i18n/UserUiI18n.const";
import { ISelectReasonStepProps } from "../interfaces/ISelectReasonStepProps";
import "../styles/select-reason-step.css";

export const SelectReasonStep: FunctionComponent<ISelectReasonStepProps> = (props) => {
    const describedById = useId();
    const updateText = (newText: string): void => {
        props.onNewTextSet(newText);
    };

    return (
        <div className="uui-temporary-access__step-container">
            <h3 id={describedById} className="uui-temporary-access__title">
                {userUiI18n.getString("temporary_access.steps.provide_reason.title", { stepNumber: "1" })}
            </h3>
            <p className="uui-temporary-access__description">{userUiI18n.getString("temporary_access.steps.provide_reason.description")}</p>
            <Textarea
                ariaLabel={userUiI18n.getString("temporary_access.steps.provide_reason.a11y.text_area")}
                className="uui-select-reason-step__textarea"
                ariaDescribedBy={describedById}
                value={props.value}
                onChange={updateText}
                required={true}
            />
        </div>
    );
};
